module.exports = __webpack_public_path__ + "static/media/16.c495b470.svg";